import * as Yup from 'yup';

import type { TestProps } from './test.types';
import { type Status, Request } from './request.types';

const schema = Yup.object({
	id: Yup.number().defined().optional(),
	name: Yup.string().default('').required('Required'),
	phone: Yup.string()
		.default('')
		.nullable()
		.transform((value) => (value == null ? '' : value)),
	email: Yup.string().email('Invalid email').default(''),
	address: Yup.string().default('').required('Required'),
	tests: Yup.array().of(Yup.mixed<TestProps>()).default([]),
	isBulk: Yup.boolean().optional(),
	ccRecipients: Yup.array().of(Yup.string().email('Invalid email')).default([]),
});

const formatTestsPayload = (tests: TestProps[]) =>
	tests.map((test) => {
		return Number(test.id);
	});

const isOnsiteTesting = (id: string | number) => {
	return Number(id) === Number(process.env.REACT_APP_PES_ONSITE_TESTING_TESTING_CENTRE_ID);
};

const isEditable = (requestStatus: Status) => requestStatus === Request.status.readyForPayment;

export const isLocationOnsite = (testingCentres: SupplierProps[], location: string) => {
	return !testingCentres.some((centre) => location.includes(centre.name));
};

export const Supplier = {
	schema,
	formatTestsPayload,
	isOnsiteTesting,
	isEditable,
};

export type SupplierProps = Yup.InferType<typeof Supplier.schema>;
